import { createSelector } from 'reselect';

// selectors
const getIsLoading = (state) => state?.loading?.isLoading;
const getDeviceInteraction = (state) => state?.config?.deviceInteraction ?? {};
const getLanguage = (state) => state?.config?.language ?? {};
const getAppPath = (state) => state?.config?.appPath ?? '';
const getVideoCarousel = (state) => state?.videoCarousel ?? {};

export const getVideoCarouselState = createSelector(
    [getVideoCarousel, getDeviceInteraction, getLanguage, getIsLoading, getAppPath],
    (videoCarousel, deviceInteraction, language, isLoading, appPath) => {
        return {
            videoCarousel,
            deviceInteraction,
            isLoading,
            language,
            appPath
        };
    }
);
